import { useMemo } from 'preact/hooks';
import styled from 'styled-components';
import { space, variant } from 'styled-system';
import pointBreaks from '@styles/styleConstants';
import useBrowserDetect from '@hooks/useBrowserDetect';

const browser = useBrowserDetect();

const BaseInput = styled.input(
  ({
    hasError,
    fluid,
  }) => {
    const inputWidth = useMemo(() => (fluid ? '100%' : 'auto'), [fluid]);

    return `
    font-size: 0.875rem;
    padding: 0.75em 1.125em;
    border-radius: 0.5em;
    color: var(--text-input);
    border: 1px solid ${hasError ? 'var(--red-400)' : 'var(--input-border)'};
    transition: all 250ms ease-in-out;
    background-color: var(--input-bg);
    width: ${inputWidth};
    min-height: 44px;

    @media screen and (max-width: ${pointBreaks.sm}) {
      font-size: 1rem;
    }

    ::placeholder {
      color: var(--text-placeholder);
    }

   &[type="date"]
    {
      -webkit-appearance: textfield;
      -moz-appearance: textfield;
      height: 2.75em;
      -webkit-appearance: none;
      -moz-appearance: none;
      background-image: ${browser === 'Firefox' || browser === 'IE' ? 'none' : 'url("data:image/svg+xml;base64,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")'};
      background-repeat: no-repeat;
      background-position-x: 100%;
      background-position-y: 2px;
    }

    ${!hasError && `
      :focus {
        border-color: var(--input-focused-border);
      }
      :focus-visible {
        outline: none;
      }
      :disabled {
        cursor: not-allowed;
        background-color: var(--input-disabled);
      }
    `};
  `;
  },
  variant({
    variants: {
      panel: {
        background: 'var(--input-bg-panel)',
      },
    },
  }),
  space,
);

export default BaseInput;
